import React from 'react';
import { Button, NavDropdown } from 'react-bootstrap';
import { LanguageOutlined, ToggleOff, ToggleOn } from '@material-ui/icons';

import { useLocalization } from '../contexts/LocalizationContext';
import { useAuth } from '../contexts/AuthContext';

const NavigationLangSelection = () => {
  const { locale, sortedLocales, setLocale, localize } = useLocalization();
  const auth = useAuth();

  return (
    <>
      <div className='d-none d-lg-block px-1'>
        {sortedLocales?.length > 0 && (
          <NavDropdown
            align='end'
            title={
              <span className='me-1'>
                <LanguageOutlined /> {locale?.toUpperCase()}{' '}
              </span>
            }
            id='mainnav-lang-dropdown'>
            {sortedLocales?.map((lang) => (
              <NavDropdown.Item
                onClick={() => setLocale(lang)}
                key={lang}
                as={'button'}>
                {localize(`common.btn.locale.${lang}`)}{' '}
                <small>{`(${lang.toUpperCase()})`}</small>
              </NavDropdown.Item>
            ))}
            {auth.authLevel <= 1 && (
              <NavDropdown.Item as={'button'}>
                <ToggleLocalizationEditMode />
              </NavDropdown.Item>
            )}
          </NavDropdown>
        )}
      </div>
      <div className='d-flex justify-content-between d-lg-none w-100 gap-2'>
        {sortedLocales?.map((lang) => (
          <Button
            key={lang}
            variant='outline-secondary'
            style={{ flex: 1 }}
            className={`no-border ${locale === lang ? 'active' : ''}`}
            as={'button'}
            onClick={() => setLocale(lang)}>
            {localize(`common.btn.locale.${lang}`)}
          </Button>
        ))}
      </div>
      {auth.authLevel <= 1 && (
        <Button variant='light d-lg-none no-border'>
          <ToggleLocalizationEditMode />
        </Button>
      )}
    </>
  );
};

export function ToggleLocalizationEditMode() {
  const { edit, toggleEditMode, localize } = useLocalization();

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={toggleEditMode}
      className='d-flex justify-content-between'>
      <span className='m-auto'>
        {localize('localization.edit', { editable: false })}
      </span>
      {edit.enabled ? (
        <ToggleOn className='text-warning' />
      ) : (
        <ToggleOff className='text-secondary' />
      )}
    </div>
  );
}

export default NavigationLangSelection;
